import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'

export default {
  path: '/testpaper_manage',
  name: 'testpaperManage',
  meta: {
    title: '试卷管理',
    isAdmin: true
  },
  component: Layout,
  redirect: '/testpaper_manage/testpaper_list',
  children: [
    {
      path: 'testpaper_list',
      name: 'testpaperList',
      meta: {
        title: '试卷列表',
        isAdmin: true
      },
      component: resolve => require(['@/views/testpaperManage/testpaperList/Index.vue'], resolve),
    },
    {
      path: 'testpaper_list',
      meta: {
        title: '试卷列表',
        isAdmin: true
      },
      component: Empty,
      children: [
        {
          path: 'assign_papers',
          name: 'assignPapers',
          alias: '/assignPapers_3',
          meta: {
            title: '分配试卷',
            isAdmin: true
          },
          component: resolve => require(['@/views/testpaperManage/assignPapers/Index.vue'], resolve),
        },
      ]
    },
  ]
}
